var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.667a.429.429 0 01-.29-.112L2.787 5.983a.362.362 0 010-.538.433.433 0 01.58 0L8 9.747l4.633-4.302a.433.433 0 01.58 0c.16.148.16.39 0 .538L8.29 10.555a.426.426 0 01-.291.112h.002z",
    fill: "#282828"
  })));
}
export default SvgArrowDown;